import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import { submitContact } from "@/lib/api";
import { Field, Consent, SuccessBox, useFormHelpers } from "./shared";

const init = { name: "", email: "", message: "", consent: false };

export function ContactForm() {
  const { t } = useLang();
  const s = t.contact.simple;
  const { c, lang, isEmail, errorMessage } = useFormHelpers();
  const [f, setF] = useState(init);
  const [err, setErr] = useState({});
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));

  const onSubmit = async (ev) => {
    ev.preventDefault();
    const e = {};
    if (f.name.trim().length < 2) e.name = c.required;
    if (!isEmail(f.email)) e.email = c.invalidEmail;
    if (f.message.trim().length < 5) e.message = c.required;
    if (!f.consent) e.consent = c.consentRequired;
    setErr(e);
    if (Object.keys(e).length) return;
    setBusy(true);
    try {
      const res = await submitContact({ ...f, lang });
      setDone(res.reference);
      toast.success(c.success);
    } catch (er) { toast.error(errorMessage(er)); } finally { setBusy(false); }
  };

  if (done) return <SuccessBox reference={done} id="contact-form" onReset={() => { setDone(null); setF(init); }} />;

  return (
    <form onSubmit={onSubmit} noValidate className="space-y-5" data-testid="contact-form">
      <div>
        <h2 className="font-display text-2xl font-bold text-slate-900">{s.title}</h2>
        <p className="mt-1 text-sm text-slate-600">{s.sub}</p>
      </div>
      <div className="grid gap-5 sm:grid-cols-2">
        <Field label={s.name} error={err.name} id="contact-name"><input id="contact-name" className="field" value={f.name} onChange={set("name")} data-testid="contact-name-input" /></Field>
        <Field label={s.email} error={err.email} id="contact-email"><input id="contact-email" type="email" className="field" value={f.email} onChange={set("email")} data-testid="contact-email-input" /></Field>
      </div>
      <Field label={s.message} error={err.message} id="contact-message"><textarea id="contact-message" rows={5} className="field" value={f.message} onChange={set("message")} data-testid="contact-message-textarea" /></Field>
      <Consent checked={f.consent} onChange={(v) => setF((x) => ({ ...x, consent: v }))} error={err.consent} id="contact-form" />
      <button type="submit" disabled={busy} className="btn-primary w-full disabled:opacity-60 sm:w-auto" data-testid="contact-form-submit-button">{busy ? c.sending : s.submit} <ArrowRight size={16} /></button>
    </form>
  );
}
